import {
    CTAConfiguration,
    KontentRadioMultiChoice,
    KontentRichText,
    KontentStringValue,
} from '../../../../types/KontentProps';
import { usePageDataset } from '../../../templates/PageDatasetsContext';

export interface Faq {
    id?: string;
    preferred_language: string;
    elements: CTAConfiguration & {
        question: KontentStringValue;
        answer: KontentRichText;
        blog_topic: KontentRadioMultiChoice<string>;
        country: KontentRadioMultiChoice<string>;
        wellness_type: KontentRadioMultiChoice<string>;
        product_type: KontentRadioMultiChoice<string>;
        product_family: KontentRadioMultiChoice<string>;
        content_type: KontentRadioMultiChoice<string>;
        department: KontentRadioMultiChoice<string>;
    };
}

export const useFaqs = (required = true): Faq[] => {
    return usePageDataset('pageFaqs', required)?.nodes ?? [];
};
